<template>
	<div>
		<div class="back"><el-page-header @back="startAnalysis"></el-page-header></div>
		<div class="analysisBox">
			<div class="selectedVariable">
				<div class="selectedVariableSearch">
					<span>选择算法</span>
					<span><i class="el-icon-search"></i></span>
				</div>
				<el-divider></el-divider>
				<el-menu class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose">
					<el-submenu :index="item.id" v-for="item in arithmeticList" :key="item.id">
						<template slot="title">
							<i class="el-icon-menu"></i>
							<span>{{ item.title }}</span>
						</template>
						<el-menu-item-group v-for="groupItme in item.group" :key="groupItme.id">
							<el-menu-item :index="groupItme.id" @click="activeGroup(groupItme)">{{ groupItme.title }}</el-menu-item>
						</el-menu-item-group>
					</el-submenu>
				</el-menu>
			</div>
			<div class="selectedVariable">
				<div class="selectedVariableSearch">
					<span>选择变量</span>
					<span><i class="el-icon-search"></i></span>
				</div>
				<el-divider></el-divider>
				<div class="selectedVariableFunction">
					<span>选择变量</span>
					<span @click="openPreviewDataDialog">
						<i class="el-icon-view"></i>
						预览数据
					</span>
				</div>
				<div class="selectedVariableSample">
					<draggable class="leftSample" :list="variateList" group="my-group">
						<div v-for="(item, index) in variateList" :key="index">
							<div class="hideField">{{ item }}</div>
						</div>
					</draggable>
				</div>
			</div>
			<div class="analysisResult">
				<div>
					{{ dataLabelTitle }}
					<el-divider></el-divider>
					<div class="dataLabel">
						数据标签相当于对定类变量的文本进行修改.
						<span style="color: #0080ff; cursor: pointer;">详情></span>
					</div>
					<div class="dataLabel">
						拖入
						<span>[定类]</span>
						变量 (变量数=1)
					</div>
					<div class="dataLabel">
						拖拽变量到此区域
						<div class="selectedVariableSample">
							<draggable class="leftSample" :list="pitchOnList" group="my-group">
								<div v-for="(item, index) in pitchOnList" :key="index">
									<div class="hideField">{{ item }}</div>
								</div>
							</draggable>
						</div>
					</div>
					<!-- <div class="dataLabel">
						管理标签
						<div>原数据</div>
					</div> -->
				</div>
				<div class="resultFoot">
					<el-button >重置</el-button>
					<el-button type="primary" @click="startAnalysis">开始分析</el-button>
				</div>
			</div>
			<previewData ref="previewData"></previewData>
		</div>
	</div>
</template>

<script>
import previewData from './previewData.vue';
import draggable from 'vuedraggable';
export default {
	components: {
		previewData,
		draggable
	},
	data() {
		return {
			pitchOnList: [],
			variateList: ['城市说明', '城市级别', '省份说明'],
			dataLabelTitle: '数据标签',
			activeObject: {},
			arithmeticList: [
				{
					id: '1',
					icon: '',
					title: '数据处理',
					group: [
						{
							id: '1-1',
							title: '数据标签'
						}
					]
				},
				{
					id: '2',
					icon: '',
					title: '描述性分析',
					group: [
						{
							id: '2-1',
							title: '频数分析'
						},
						{
							id: '2-2',
							title: '描述性分析'
						}
					]
				},
				{
					id: '3',
					icon: '',
					title: '研究模型可视化',
					group: [
						{
							id: '3-1',
							title: '热词分析'
						}
					]
				}
			]
		};
	},
	created() {},
	methods: {
		startAnalysis() {
			this.$emit('subAnalysis');
		},
		activeGroup(valData) {
			this.dataLabelTitle = valData.title;
			this.activeObject = valData;
		},
		handleOpen(key, keyPath) {
			// console.log('打开',key, keyPath);
		},
		handleClose(key, keyPath) {
			// console.log('关闭',key, keyPath);
		},
		openPreviewDataDialog() {
			this.$refs.previewData.loadData();
		}
	}
};
</script>

<style lang="scss" scoped>
.back {
	margin-left: 90px;
	padding-top: 10px;
	// background-color: #ffffff;
}
.analysisBox {
	margin-left: 90px;
	padding: 10px 20px 20px 20px;
	display: flex;
	.selectedVariable {
		width: 260px;
		min-height:680px;
		background-color: rgba(255, 255, 255, 1);
		padding: 20px;
		.selectedVariableSearch {
			display: flex;
			justify-content: space-between;
		}
		.selectedVariableFunction {
			display: flex;
			justify-content: space-between;
			color: #0080ff;
			cursor: pointer;
		}
		.selectedVariableSample {
			margin-top: 10px;
			margin-bottom: 0px;
			min-height: 680px;
			background-color: rgb(230, 230, 230);
			cursor: auto;
			.leftSample {
				overflow-y: auto;
				.hideField {
					padding: 0px 10px 0px 10px;
					margin-top: 10px;
					height: 30px;
					line-height: 30px;
					cursor: pointer;
				}
				.hideField:hover {
					background-color: #d6eafb;
					color: #333;
				}
			}
		}
	}
	.analysisResult {
		flex: 1;
		padding: 20px;
		margin-left: 10px;
		background-color: rgba(255, 255, 255, 1);
		position: relative;
		.dataLabel {
			margin-bottom: 20px;
		}
		.resultFoot {
			position: absolute;
			bottom: 20px;
			right: 20px;
			text-align: right;
		}
		.selectedVariableSample {
			margin-top: 10px;
			margin-bottom: 0px;
			min-height: 380px;
			background-color: rgb(230, 230, 230);
			cursor: auto;
			.leftSample {
				overflow-y: auto;
				.hideField {
					padding: 0px 10px 0px 10px;
					margin-top: 10px;
					height: 30px;
					line-height: 30px;
					cursor: pointer;
				}
				.hideField:hover {
					background-color: #d6eafb;
					color: #333;
				}
			}
		}
	}
}
</style>
